module.exports = __webpack_public_path__ + "fonts/icons/cm-icons.woff2?724c500077ca24588ebc14c586d8e164";